module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home",
    style: (_vm.bgall)
  }, [_c('h3', {
    staticClass: "caption"
  }, [_vm._v("每日天文图片")]), _vm._v(" "), _c('input', {
    staticClass: "date_input",
    attrs: {
      "placeholder": "Select date..."
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "intro"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.apod.title))]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.apod.explanation))]), _vm._v(" "), _c('div', {
    staticClass: "more"
  }, [_c('p', [_vm._v("author: " + _vm._s(_vm.apod.copyright || "anonymous"))]), _vm._v(" "), _c('p', [_vm._v("date: " + _vm._s(_vm.apod.date))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-0a38f03d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home.vue
// module id = 38
// module chunks = 1